import React from "react";
import "./BannerHome.css";

export default function BannerHome() {
  return (
    <section className="banner-home">
      <div className="banner-color">
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-title">¿Quiénes somos?</h1>
            <p className="banner-subtitle">
              Empresa costarricense con proyección internacional, más de 11 años en medicina estética, 
              representando marcas certificadas y de alta gama. Ofrecemos insumos de calidad, 
              seguridad comprobada y capacitación continua para profesionales del sector.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}